import React from "react";
import StatusBarButton from "../StatusBarButton/StatusBarButton";

interface HidingButtonProps {
    readonly hidden: boolean;
    readonly title: string;
    readonly onShow: () => void;
    readonly children: React.ReactChild;
    readonly className?: string;
}

export default function HidingButton({
    hidden,
    title,
    onShow,
    children,
    className
}: HidingButtonProps) {
    return hidden ? (
        <StatusBarButton className={className} onClick={onShow}>
            {title}
        </StatusBarButton>
    ) : (
        <>{children}</>
    );
}
